export const MAX_BADGES_LIMIT = 5
